
























import Vue from 'vue'

export default Vue.extend({
  props: {
    ratios: {
      type: Array,
      default: () => [],
    },
    colors: {
      type: Array,
      default: () => [],
    },
    labels: {
      type: Array,
      default: () => [],
    },
    max: {
      type: Number,
      default: 100,
    },
  },
  computed: {
    adjustedMax(): number {
      return Math.max(
        this.ratios.reduce((acc, cur) => acc + cur, 0),
        this.max
      )
    },
    widthByRatio(): number[] {
      return this.ratios.map(ratio => Math.min(100, Math.max(0, (ratio * 100) / this.adjustedMax)))
    },
  },
})
